"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isElement = void 0;
function isElement(node) {
    return node && node.nodeType === 1;
}
exports.isElement = isElement;
//# sourceMappingURL=is-element.js.map